<template>
  <div id="main">
    <div class="nav" :style="'background:' + bgColor">
      <div class="nav-top">
        <a
          :class="`nav-hamburger ${isExpanded ? 'active' : ''}`"
          @click="isExpanded = !isExpanded"
        >
          <span></span>
        </a>
        <div class="nav-profile">
          <i
            v-if="!profile.url"
            class="fas fa-user-circle"
            style="font-size:36px;color:#39a2d9"
          ></i>
          <img class="nav-avatar" :src="profile.url" v-else />
          <div class="nav-name-role">
            <div class="nav-user-name">{{ profile.name }}</div>
            <div class="nav-user-role">{{ profile.role }}</div>
          </div>
        </div>
      </div>
      <div :class="`nav-items${isExpanded ? '-expanded' : ''}`">
        <div
          class="nav-item"
          v-for="(item, index) in items"
          :key="index"
          :class="{ active: item.id === selectedNav }"
          @click="
            $emit('update:selectedNav', item.id);
            isExpanded = false;
          "
        >
          <a class="nav-item-a">
            <div class="nav-item-icon">
              <i class="fa" :class="item.icon"></i>
            </div>
            <div class="nav-item-desc">{{ item.title }}</div>
          </a>
        </div>
        <div class="nav-item" @click="$emit('update:isLoggedIn', false)">
          <a class="nav-item-a">
            <div class="nav-item-icon">
              <i class="fas fa-arrow-left"></i>
            </div>
            <div class="nav-item-desc">LOG OUT</div>
          </a>
        </div>
      </div>
      <div class="logo-container">
        <slot name="logo"></slot>
      </div>
    </div>
    <div class="nav-content">
      <div class="h-100" style="overflow-y:auto;">
        <slot name="content"></slot>
      </div>
      <div class="footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bgColor: {
      type: String,
      default: '#001b3d'
    },
    profile: Object,
    items: Array,
    isLoggedIn: Boolean,
    selectedNav: String
  },
  data() {
    return {
      isExpanded: false
    };
  }
};
</script>

<style scoped>
#main {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: row;
  flex-flow: row;
  height: 100%;
}
.nav {
  -webkit-flex: 1;
  flex: 1;
  padding: 0.5em;
  display: flex;
  flex-flow: column;
}
.nav-item {
  color: rgb(169, 199, 221);
  border-bottom: 1px solid rgb(255, 255, 255, 0.1);
  cursor: pointer;
}
.nav-item-a {
  display: -webkit-flex;
  display: flex;
  align-items: center;
  transition: transform 0.5s;
}
.nav-item.active {
  background-color: rgba(154, 223, 250, 0.3);
}
.nav-item-a:hover {
  transform: translateX(5px);
}
.nav-item-icon {
  font-size: 24px;
  width: 60px;
  text-align: center;
}
.nav-item-desc {
  -webkit-flex: 1;
  flex: 1;
  font-size: 0.8em;
}
.nav-profile {
  padding: 1rem;
  border-bottom: 1px solid rgb(255, 255, 255, 0.1);
  position: relative;
  display: flex;
}
.nav-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.nav-avatar-menu {
  background: #39a2d9;
  box-shadow: 0 2px 15px 0 rgba(45, 130, 255, 0.15);
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0px;
  overflow: hidden;
  opacity: 0;
  transition: all 0.3s ease;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-flow: column;
  flex-flow: column;
}
.nav-avatar-menu-content {
  height: 50px;
  color: #001b3d;
  padding: 10px;
  border: none;
  border-top: 1px solid rgb(255, 255, 255, 0.1);
  flex: 1 1 auto;
  background: #39a2d9;
}
.nav-avatar-menu-content:hover {
  cursor: pointer;
  color: white;
}
.nav-avatar-menu:hover {
  opacity: 1;
}
.nav-user-name {
  display: block;
  font-size: 1em;
  color: white;
  text-transform: capitalize;
}
.nav-user-role {
  display: block;
  font-size: 0.8em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
}
.nav-name-role {
  margin-left: 10px;
}
.nav-hamburger {
  padding-top: 15px;
  display: none;
}
.nav-hamburger span,
.nav-hamburger span:before,
.nav-hamburger span:after {
  cursor: pointer;
  border-radius: 1px;
  height: 5px;
  width: 35px;
  background: white;
  position: absolute;
  display: block;
  content: '';
  transition: all 500ms ease;
}
.nav-hamburger span:before {
  top: -10px;
}
.nav-hamburger span:after {
  bottom: -10px;
}
.nav-hamburger.active span {
  background-color: transparent;
}
.nav-hamburger.active span:before,
.nav-hamburger.active span:after {
  top: 0;
}
.nav-hamburger.active span:before {
  transform: rotate(45deg);
}
.nav-hamburger.active span:after {
  transform: rotate(-45deg);
}
.nav-content {
  overflow-y: auto;
  background: white;
  -webkit-flex: 5;
  flex: 5;
  display: flex;
  flex-flow: column;
}
.logo-container {
  flex: 1 1 auto;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 20px;
}
.footer {
  flex: 1 1 auto;
  display: flex;
  align-items: flex-end;
  padding: 20px;
}
@media all and (max-width: 1024px) {
  #main {
    margin: 0;
    border-radius: 0;
  }
  .nav-profile {
    display: none;
  }
  .logo-container {
    display: none;
  }
  .nav-item-a {
    flex-flow: column;
  }
}
@media all and (max-width: 768px) {
  #main {
    display: block;
  }
  .nav-items,
  .nav-items-expanded {
    overflow: hidden;
    transition: all 0.15s;
  }
  .nav-items {
    max-height: 0px;
  }
  .nav-items-expanded {
    max-height: 500px;
  }
  .nav-item-a {
    -webkit-flex-flow: row;
    flex-flow: row;
  }
  .nav-hamburger {
    display: block;
    cursor: pointer;
  }
  .nav-avatar {
    width: 40px;
    border-radius: none;
  }
  .nav-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .nav-profile {
    padding: 0;
    padding-top: 2px;
    border: none;
    visibility: hidden;
    display: flex;
  }
  .nav-avatar-menu {
    width: 100px;
    height: 100px;
    top: 0px;
    left: -60px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .nav-avatar {
    width: 50px;
  }
  .nav-item-desc {
    display: none;
  }
  .nav-content {
    -webkit-flex: 7;
    flex: 7;
  }
}
</style>
